(function($) {
    /*!
     * Slidebars - A jQuery Framework for Off-Canvas Menus and Sidebars
     * Version: 2.0.2
     * Url: http://www.adchsm.com/slidebars/
     * Author: Adam Charles Smith
     * Author url: http://www.adchsm.com/
     * License: MIT
     * License url: http://www.adchsm.com/slidebars/license/
     */

    var slidebars = function() {
        /**
         * Setup
         */

        // Cache all canvas elements
        var canvas = $("[canvas]"),
            // Object of Slidebars
            offCanvas = {},
            // Variables, permitted sides and styles
            init = false,
            registered = false,
            sides = ["top", "right", "bottom", "left"],
            styles = ["reveal", "push", "overlay", "shift"],
            /**
             * Get Animation Properties
             */

            getAnimationProperties = function(id) {
                // Variables
                var elements = $(),
                    amount = "0px, 0px",
                    duration =
                        parseFloat(
                            offCanvas[id].element.css("transitionDuration"),
                            10
                        ) * 1000;

                // Elements to animate
                if (
                    offCanvas[id].style === "reveal" ||
                    offCanvas[id].style === "push" ||
                    offCanvas[id].style === "shift"
                ) {
                    elements = elements.add(canvas);
                }

                if (
                    offCanvas[id].style === "push" ||
                    offCanvas[id].style === "overlay" ||
                    offCanvas[id].style === "shift"
                ) {
                    elements = elements.add(offCanvas[id].element);
                }

                // Amount to animate
                if (offCanvas[id].active) {
                    if (offCanvas[id].side === "top") {
                        amount = "0px, " + offCanvas[id].element.css("height");
                    } else if (offCanvas[id].side === "right") {
                        amount =
                            "-" + offCanvas[id].element.css("width") + ", 0px";
                    } else if (offCanvas[id].side === "bottom") {
                        amount = "0px, -" + offCanvas[id].element.css("height");
                    } else if (offCanvas[id].side === "left") {
                        amount = offCanvas[id].element.css("width") + ", 0px";
                    }
                }

                // Return animation properties
                return {
                    elements: elements,
                    amount: amount,
                    duration: duration
                };
            },
            /**
             * Slidebars Registration
             */

            registerSlidebar = function(id, side, style, element) {
                // Check if Slidebar is registered
                if (isRegisteredSlidebar(id)) {
                    throw "Error registering Slidebar, a Slidebar with id '" +
                        id +
                        "' already exists.";
                }

                // Register the Slidebar
                offCanvas[id] = {
                    id: id,
                    side: side,
                    style: style,
                    element: element,
                    active: false
                };
            },
            isRegisteredSlidebar = function(id) {
                // Return if Slidebar is registered
                if (offCanvas.hasOwnProperty(id)) {
                    return true;
                } else {
                    return false;
                }
            };

        /**
         * Initialization
         */

        this.init = function(callback) {
            // Check if Slidebars has been initialized
            if (init) {
                throw "Slidebars has already been initialized.";
            }

            // Loop through and register Slidebars
            if (!registered) {
                $("[off-canvas]").each(function() {
                    // Get Slidebar parameters
                    var parameters = $(this)
                        .attr("off-canvas")
                        .split(" ", 3);

                    // Make sure a valid id, side and style are specified
                    if (
                        !parameters ||
                        !parameters[0] ||
                        sides.indexOf(parameters[1]) === -1 ||
                        styles.indexOf(parameters[2]) === -1
                    ) {
                        throw "Error registering Slidebar, please specifiy a valid id, side and style'.";
                    }

                    // Register Slidebar
                    registerSlidebar(
                        parameters[0],
                        parameters[1],
                        parameters[2],
                        $(this)
                    );
                });

                // Set registered variable
                registered = true;
            }

            // Set initialized variable
            init = true;

            // Set CSS
            this.css();

            // Trigger event
            $(events).trigger("init");

            // Run callback
            if (typeof callback === "function") {
                callback();
            }
        };

        this.exit = function(callback) {
            // Check if Slidebars has been initialized
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }

            // Exit
            var exit = function() {
                // Set init variable
                init = false;

                // Trigger event
                $(events).trigger("exit");

                // Run callback
                if (typeof callback === "function") {
                    callback();
                }
            };

            // Call exit, close open Slidebar if active
            if (this.getActiveSlidebar()) {
                this.close(exit);
            } else {
                exit();
            }
        };

        /**
         * CSS
         */

        this.css = function(callback) {
            // Check if Slidebars has been initialized
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }

            // Loop through Slidebars to set negative margins
            for (var id in offCanvas) {
                // Check if Slidebar is registered
                if (isRegisteredSlidebar(id)) {
                    // Calculate offset
                    var offset;

                    if (
                        offCanvas[id].side === "top" ||
                        offCanvas[id].side === "bottom"
                    ) {
                        offset = offCanvas[id].element.css("height");
                    } else {
                        offset = offCanvas[id].element.css("width");
                    }

                    // Apply negative margins
                    if (
                        offCanvas[id].style === "push" ||
                        offCanvas[id].style === "overlay" ||
                        offCanvas[id].style === "shift"
                    ) {
                        offCanvas[id].element.css(
                            "margin-" + offCanvas[id].side,
                            "-" + offset
                        );
                    }
                }
            }

            // Reposition open Slidebars
            if (this.getActiveSlidebar()) {
                this.open(this.getActiveSlidebar());
            }

            // Trigger event
            $(events).trigger("css");

            // Run callback
            if (typeof callback === "function") {
                callback();
            }
        };

        /**
         * Controls
         */

        this.open = function(id, callback) {
            // Check if Slidebars has been initialized
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }

            // Check if id wasn't passed or if Slidebar isn't registered
            if (!id || !isRegisteredSlidebar(id)) {
                throw "Error opening Slidebar, there is no Slidebar with id '" +
                    id +
                    "'.";
            }

            // Open
            var open = function() {
                // Set active state to true
                offCanvas[id].active = true;

                // Display the Slidebar
                offCanvas[id].element.css("display", "block");

                // Trigger event
                $(events).trigger("opening", [offCanvas[id].id]);

                // Get animation properties
                var animationProperties = getAnimationProperties(id);

                // Apply css
                animationProperties.elements.css({
                    "transition-duration": animationProperties.duration + "ms",
                    transform: "translate(" + animationProperties.amount + ")"
                });

                // Transition completed
                setTimeout(function() {
                    // Trigger event
                    $(events).trigger("opened", [offCanvas[id].id]);

                    // Run callback
                    if (typeof callback === "function") {
                        callback();
                    }
                }, animationProperties.duration);
            };

            // Call open, close open Slidebar if active
            if (this.getActiveSlidebar() && this.getActiveSlidebar() !== id) {
                this.close(open);
            } else {
                open();
            }
        };

        this.close = function(id, callback) {
            // Shift callback arguments
            if (typeof id === "function") {
                callback = id;
                id = null;
            }

            // Check if Slidebars has been initialized
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }

            // Check if id was passed but isn't a registered Slidebar
            if (id && !isRegisteredSlidebar(id)) {
                throw "Error closing Slidebar, there is no Slidebar with id '" +
                    id +
                    "'.";
            }

            // If no id was passed, get the active Slidebar
            if (!id) {
                id = this.getActiveSlidebar();
            }

            // Close a Slidebar
            if (id && offCanvas[id].active) {
                // Set active state to false
                offCanvas[id].active = false;

                // Trigger event
                $(events).trigger("closing", [offCanvas[id].id]);

                // Get animation properties
                var animationProperties = getAnimationProperties(id);

                // Apply css
                animationProperties.elements.css("transform", "");

                // Transition completetion
                setTimeout(function() {
                    // Remove transition duration
                    animationProperties.elements.css("transition-duration", "");

                    // Hide the Slidebar
                    offCanvas[id].element.css("display", "");

                    // Trigger event
                    $(events).trigger("closed", [offCanvas[id].id]);

                    // Run callback
                    if (typeof callback === "function") {
                        callback();
                    }
                }, animationProperties.duration);
            }
        };

        this.toggle = function(id, callback) {
            // Check if Slidebars has been initialized
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }

            // Check if id wasn't passed or if Slidebar isn't registered
            if (!id || !isRegisteredSlidebar(id)) {
                throw "Error toggling Slidebar, there is no Slidebar with id '" +
                    id +
                    "'.";
            }

            // Check Slidebar state
            if (offCanvas[id].active) {
                // It's open, close it
                this.close(id, function() {
                    // Run callback
                    if (typeof callback === "function") {
                        callback();
                    }
                });
            } else {
                // It's closed, open it
                this.open(id, function() {
                    // Run callback
                    if (typeof callback === "function") {
                        callback();
                    }
                });
            }
        };

        /**
         * Active States
         */

        this.isActive = function(id) {
            // Return init state
            return init;
        };

        this.isActiveSlidebar = function(id) {
            // Check if Slidebars has been initialized
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }

            // Check if id wasn't passed
            if (!id) {
                throw "You must provide a Slidebar id.";
            }

            // Check if Slidebar is registered
            if (!isRegisteredSlidebar(id)) {
                throw "Error retrieving Slidebar, there is no Slidebar with id '" +
                    id +
                    "'.";
            }

            // Return the active state
            return offCanvas[id].active;
        };

        this.getActiveSlidebar = function() {
            // Check if Slidebars has been initialized
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }

            // Variable to return
            var active = false;

            // Loop through Slidebars
            for (var id in offCanvas) {
                // Check if Slidebar is registered
                if (isRegisteredSlidebar(id)) {
                    // Check if it's active
                    if (offCanvas[id].active) {
                        // Set the active id
                        active = offCanvas[id].id;
                        break;
                    }
                }
            }

            // Return
            return active;
        };

        this.getSlidebars = function() {
            // Check if Slidebars has been initialized
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }

            // Create an array for the Slidebars
            var slidebarsArray = [];

            // Loop through Slidebars
            for (var id in offCanvas) {
                // Check if Slidebar is registered
                if (isRegisteredSlidebar(id)) {
                    // Add Slidebar id to array
                    slidebarsArray.push(offCanvas[id].id);
                }
            }

            // Return
            return slidebarsArray;
        };

        this.getSlidebar = function(id) {
            // Check if Slidebars has been initialized
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }

            // Check if id wasn't passed
            if (!id) {
                throw "You must pass a Slidebar id.";
            }

            // Check if Slidebar is registered
            if (!id || !isRegisteredSlidebar(id)) {
                throw "Error retrieving Slidebar, there is no Slidebar with id '" +
                    id +
                    "'.";
            }

            // Return the Slidebar's properties
            return offCanvas[id];
        };

        /**
         * Events
         */

        this.events = {};
        var events = this.events;

        /**
         * Resizes
         */

        $(window).on("resize", this.css.bind(this));
    };

    window.slidebars = slidebars;

    /**
     * END SLIDEBARS
     */

    // BlockUI
    $.blockUI.defaults.message = "Please wait...";
    $.blockUI.defaults.centerY = false;
    $.blockUI.defaults.css.top = "41px";
    $.blockUI.defaults.css.right = "15px";
    $.blockUI.defaults.css.left = "";
    $.blockUI.defaults.css.width = "auto";
    $.blockUI.defaults.css.border = "none";
    $.blockUI.defaults.css.backgroundColor = "#343a40";
    $.blockUI.defaults.css.color = "#fff";
    $.blockUI.defaults.css.padding = "10px 20px";
    $.blockUI.defaults.css["border-radius"] = "4px";
    $.blockUI.defaults.overlayCSS.backgroundColor = "#fff";
    $.blockUI.defaults.overlayCSS.opacity = 0;

    var RISSB = {
        fn: {},
        var: {
            recaptchaToken: false
        }
    };

    RISSB.fn.updateQSParams = function(key, value, isArray) {
        const params = new URLSearchParams(location.search);

        isArray = isArray ? true : false;

        if (!value) {
            params.delete(key);
        } else {
            if (isArray) {
                if (params.has(key)) {
                    params.delete(key);
                }

                $.each(value, function(ind, val) {
                    if (ind === 0) {
                        params.set(key, val);
                    } else {
                        params.append(key, val);
                    }
                });
            } else {
                params.set(key, value);
            }
        }

        window.history.replaceState(
            {},
            "",
            decodeURIComponent(`${location.pathname}?${params}`)
        );
    };

    RISSB.fn.loadQueue = function(force = false) {
        const CACHE_KEY = 'rissbQueueCache';

        const template = $("#js-queue-item").html();
        const $list = $(".js-list-products-queue");

        const cachedData = localStorage.getItem(CACHE_KEY);

        const renderQueue = (data) => {
            $(".js-queue-count").text(data.count_readable);
            $(".js-queue-size").text(data.size);
            $(".js-clear-queue").toggleClass("d-none", data.count == 0);
            $(".js-download-queue").toggleClass("d-none", data.count == 0);

            const rendered = Mustache.render(template, data);
            $list.html(rendered);
        };

        if (!force && cachedData) {
            const parsedData = JSON.parse(cachedData);
            renderQueue(parsedData);
        } else {
            $.get("/api/products/queue", function(res) {
                localStorage.setItem(CACHE_KEY, JSON.stringify(res.data));
                renderQueue(res.data);
            });
        }
    };

    // Ref: http://locutus.io/php/strings/number_format/
    RISSB.fn.numberFormat = function(number, decimals, decPoint, thousandsSep) {
        var number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
        var n = !isFinite(+number) ? 0 : +number;
        var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
        var sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
        var dec = typeof decPoint === "undefined" ? "." : decPoint;
        var s = "";

        var toFixedFix = function(n, prec) {
            var k = Math.pow(10, prec);

            return "" + (Math.round(n * k) / k).toFixed(prec);
        };

        s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");

        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }

        if ((s[1] || "").length < prec) {
            s[1] = s[1] || "";
            s[1] += new Array(prec - s[1].length + 1).join("0");
        }

        return s.join(dec);
    };

    RISSB.fn.clearDropdownFilter = function(cb) {
        $(".js-clear-dropdown-filter").on("click", function() {
            var $this = $(this);

            $this
                .closest(".dropdown-menu")
                .find('input[type="checkbox"]')
                .prop("checked", false);
            $this
                .closest(".dropdown-menu")
                .find('input[type="checkbox"]')
                .eq(0)
                .change();
            $this.closest(".dropdown-menu").removeClass("show");

            var names = $this
                .closest(".dropdown-menu")
                .find('input[type="checkbox"]')
                .map(function() {
                    return $(this).attr("name");
                })
                .sort();

            $.each($.unique(names), function(index, name) {
                RISSB.fn.updateQSParams(name, [], true);
            });

            cb && cb();
        });
    };

    RISSB.fn.ucwords = function(str) {
        return str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
            return letter.toUpperCase();
        });
    };

    RISSB.fn.clearFields = function($el) {
        $el.find(":input").each(function() {
            switch (this.type) {
                case "password":
                case "text":
                case "textarea":
                case "file":
                case "select-one":
                case "select-multiple":
                case "date":
                case "number":
                case "tel":
                case "email":
                    $(this).val("");
                    break;

                case "checkbox":
                case "radio":
                    this.checked = false;
                    break;
            }
        });
    };

    RISSB.fn.showAlert = function(msg, type) {
        RISSB.fn.clearAlert();

        $(".alert-container").append(
            $("<div/>")
                .addClass("alert alert-dismissible alert-" + type)
                .html(msg)
        );

        $("html,body").animate(
            {
                scrollTop: $(".alert-container").offset().top - 50
            },
            250
        );
    };

    RISSB.fn.clearAlert = function(msg, type) {
        $(".alert-container").empty();
    };

    RISSB.fn.showFormErrors = function($form, errors) {
        $.each(errors, function(key, val) {
            var $input = $form.find('[name="' + key + '"]');
            var $parent;

            if (!$input.length) {
                $input = $form.find('[name="' + key + '[]"]'); // probably array
            }

            if (key.indexOf(".") !== -1) {
                var _keys = key.split(".");

                switch (_keys.length) {
                    case 2:
                        $input = $form.find('[name="' + _keys[0] + '[]"]');
                        break;

                    case 3:
                        $input = $form.find(
                            '[name="' +
                                _keys[0] +
                                "[" +
                                _keys[1] +
                                "]" +
                                "[" +
                                _keys[2] +
                                ']"]'
                        );
                        break;

                    case 4:
                        $input = $form.find(
                            '[name="' +
                                _keys[0] +
                                "[" +
                                _keys[1] +
                                "]" +
                                "[" +
                                _keys[2] +
                                "]" +
                                "[" +
                                _keys[3] +
                                ']"]'
                        );
                        break;
                }
            }

            if (
                $.inArray(key, [
                    "email",
                    "pass1",
                    "register_as_survey_manage"
                ]) !== -1 &&
                $input.closest(".form-group").hasClass("d-none")
            ) {
                $input = $form.find('[name="' + key + '_affiliate"]'); // probably affiliate field
            }

            $input.addClass("is-invalid");

            if (val.length) {
                if ($('[data-error="' + key + '"]').length) {
                    $('[data-error="' + key + '"]').text(val);
                } else {
                    if (
                        $input.closest("[class^=col]").length &&
                        $input.closest(".form-group").hasClass("row")
                    ) {
                        $parent = $input.closest("[class^=col]");
                    } else {
                        $parent = $input.closest(".form-group");
                    }

                    $parent.find(".invalid-feedback").remove();
                    $parent.append(
                        '<div class="invalid-feedback d-block">' +
                            val +
                            "</div>"
                    );
                }
            }
        });

        if ($(".invalid-feedback").length) {
            var $firstErrorEl = $(".invalid-feedback")
                .filter(":visible")
                .eq(0);

            if ($firstErrorEl.length) {
                $("html,body").animate(
                    {
                        scrollTop: $firstErrorEl.offset().top - 120
                    },
                    250
                );
            }
        }
    };

    RISSB.fn.clearFormError = function($form, key) {
        var $input = $form.find('[name="' + key + '"]');

        if (!$input.length) {
            $input = $form.find('[name="' + key + '[]"]'); // probably array
        }

        if (key.indexOf(".") !== -1) {
            var _keys = key.split(".");

            switch (_keys.length) {
                case 2:
                    $input = $form.find('[name="' + _keys[0] + '[]"]');
                    break;

                case 3:
                    $input = $form.find(
                        '[name="' +
                            _keys[0] +
                            "[" +
                            _keys[1] +
                            "]" +
                            "[" +
                            _keys[2] +
                            ']"]'
                    );
                    break;

                case 4:
                    $input = $form.find(
                        '[name="' +
                            _keys[0] +
                            "[" +
                            _keys[1] +
                            "]" +
                            "[" +
                            _keys[2] +
                            "]" +
                            "[" +
                            _keys[3] +
                            ']"]'
                    );
                    break;
            }
        }

        $input.removeClass("is-invalid");

        if ($input.is(":checkbox")) {
            $input
                .closest(".form-group")
                .find(".invalid-feedback")
                .remove();
            $input.next(".invalid-feedback").remove();
        } else {
            if (
                $input.closest("[class^=col]").length &&
                $input.closest(".form-group").hasClass("row")
            ) {
                $input
                    .closest("[class^=col]")
                    .find(".invalid-feedback")
                    .remove();
            } else {
                $input
                    .closest(".form-group")
                    .find(".invalid-feedback")
                    .remove();
            }
        }

        if ($('[data-error="' + key + '"]').length) {
            $('[data-error="' + key + '"]').empty();
        }
    };

    RISSB.fn.clearFormErrors = function($form) {
        $form.find(".is-invalid").removeClass("is-invalid");
        $form
            .find(".invalid-feedback")
            .not("[data-error]")
            .remove();
        $form.find("[data-error]").empty();
    };

    RISSB.fn.setBtnPending = function($el) {
        $el.html(
            '<i class="fas fa-spinner fa-spin fa-fw"></i> ' +
                $el.data("text-pending")
        );
    };

    RISSB.fn.setBtnOriginal = function($el) {
        $el.html($el.data("text-original"));
    };

    RISSB.fn.block = function(message) {
        $.blockUI({
            message:
                '<i class="fas fa-spinner fa-spin fa-fw"></i> ' +
                (message || "Please wait...")
        });
    };

    RISSB.fn.unblock = function() {
        $.unblockUI();
    };

    RISSB.fn.ajaxForm = function(config) {
        var $formEl = $(config.form);
        var $btn = $formEl.find('[type="submit"]');
        var showErrors = config.hasOwnProperty("showErrors")
            ? config.showErrors
            : true;
        var showBlockUi = config.hasOwnProperty("showBlockUi")
            ? config.showBlockUi
            : true;

        $btn.data("text-original", $btn.text());

        var $ajaxForm = $formEl.ajaxForm({
            clearForm: config.hasOwnProperty("clearForm")
                ? config.clearForm
                : true,
            beforeSerialize: function($form, options) {
                config.beforeSerializeCb &&
                    config.beforeSerializeCb($form, options);
            },
            beforeSubmit: function(arr, $form, options) {
                var canSubmit = true;
                RISSB.fn.setBtnPending($btn);
                RISSB.fn.clearFormErrors($formEl);
                showBlockUi && RISSB.fn.block();

                if (config.beforeSubmitCb) {
                    canSubmit = config.beforeSubmitCb(arr, $form, options);
                }

                if (!canSubmit) {
                    RISSB.fn.setBtnOriginal($btn);
                    showBlockUi && RISSB.fn.unblock();
                }

                return canSubmit;
            },
            success: function(res, status, xhr, $form) {
                if (res.success) {
                    config.successCb &&
                        config.successCb(res, status, xhr, $form);

                    if ($.trim(res.data.redirect) !== "") {
                        setTimeout(function() {
                            window.location = res.data.redirect;
                        }, 500);
                    }
                }
            },
            error: function(xhr, status, error) {
                var errors = JSON.parse(xhr.responseText);

                showErrors &&
                    RISSB.fn.showFormErrors($formEl, errors.data.errors);
                config.errorCb && config.errorCb(xhr, status, error);
            },
            complete: function(xhr, status) {
                RISSB.fn.setBtnOriginal($btn);
                showBlockUi && RISSB.fn.unblock();
                config.completeCb && config.completeCb(xhr, status);
            }
        });

        $ajaxForm.on("change keyup", "input, select, textarea", function() {
            if (config.hasOwnProperty("clearFormErrorCb")) {
                config.clearFormErrorCb($formEl, this);
            } else {
                RISSB.fn.clearFormError($formEl, $(this).attr("name"));
            }
        });

        return $ajaxForm;
    };

    RISSB.fn.populateProductQuickPreviewModal = function(id, selector) {
        var $this = $("#modal-product-quick-review");
        var productId = parseInt(id, 10);
        var template = $("#js-product-modal-item").html();
        var $loader = $this.find(".loader");
        $nextProduct = $(".product-" + productId).next(selector);
        $prevProduct = $(".product-" + productId).prev(selector);

        $(".js-modal-next-product, .js-modal-previous-product").addClass(
            "d-none"
        );
        $loader.removeClass("d-none");
        $this.find(".js-modal-content").empty();

        $.post("/api/product/mustache", { id: productId }, function(res) {
            $this
                .find(".js-modal-content")
                .html(Mustache.render(template, res.data));

            $(".js-modal-next-product").toggleClass(
                "d-none",
                !$nextProduct.length
            );
            $(".js-modal-previous-product").toggleClass(
                "d-none",
                !$prevProduct.length
            );
            $loader.addClass("d-none");
        });
    };

    $(document).ready(function() {
        $.fn.randomize = function(selector) {
            var $elems = selector ? $(this).find(selector) : $(this).children(),
                $parents = $elems.parent();

            $parents.each(function() {
                $(this)
                    .children(selector)
                    .not(".sticky-slide")
                    .sort(
                        function(childA, childB) {
                            // * Prevent last slide from being reordered
                            if (
                                $(childB).index() !==
                                $(this).children(selector).length - 1
                            ) {
                                return Math.round(Math.random()) - 0.5;
                            }
                        }.bind(this)
                    )
                    .detach()
                    .appendTo(this);
            });

            return this;
        };

        $(".accordion .card-header button").on("click", function() {
            var $button = $(this);
            var $collapse = $($button.data("target"));

            $collapse.on("shown.bs.collapse", function() {
                $button.find(".accordion-icon").hide();
                $button.find(".accordion-icon-alt").show();
            });

            $collapse.on("hidden.bs.collapse", function() {
                $button.find(".accordion-icon").show();
                $button.find(".accordion-icon-alt").hide();
            });
        });

        $(".hero-carousel-wrap .carousel")
            .slick({
                autoplay: true,
                autoplaySpeed: 7000,
                infinite: true,
                fade: false,
                dots: true,
                appendDots: ".hero-carousel-wrap .pagination-dots",
                appendArrows: ".hero-carousel-wrap .nav-arrows",
                prevArrow:
                    '<img src="/wp-content/themes/rissb/assets/images/carousel-left-v2.svg">',
                nextArrow:
                    '<img src="/wp-content/themes/rissb/assets/images/carousel-right-v2.svg">'
            })
            .on("afterChange", function(event, slick, currentSlide, nextSlide) {
                $(".slick-active .text-container").fadeIn(500);
            });
        /*
        $('.hero-carousel-wrap .text-container').randomize().slick({
          autoplay: true,
          autoplaySpeed: 7000,
          infinite: true,
          fade:true,
          dots:true,
          appendDots:'.hero-carousel-wrap .pagination-dots',
          appendArrows:'.hero-carousel-wrap .nav-arrows',
          prevArrow:'<img src="/wp-content/themes/rissb/assets/images/carousel-left-v2.svg">',
          nextArrow:'<img src="/wp-content/themes/rissb/assets/images/carousel-right-v2.svg">',
        });
        */
        $(".navigation .pause").click(function() {
            $(this).hide();
            $(".navigation .play").show();
            $(".hero-carousel-wrap .carousel").slick("slickPause");
        });

        $(".navigation .play").click(function() {
            $(this).hide();
            $(".pause").show();
            $(".hero-carousel-wrap .carousel").slick("slickPlay");
        });

        $("#home-latest-news").slick({
            responsive: [
                {
                    breakpoint: 5000,
                    settings: "unslick"
                },
                {
                    breakpoint: 1290,
                    settings: {
                        dots: false,
                        infinite: false,
                        arrows: false,
                        speed: 500,
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        dots: false,
                        infinite: false,
                        arrows: false,
                        speed: 500,
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        dots: false,
                        infinite: false,
                        arrows: false,
                        speed: 500,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        var $backToTop = $("a.back-to-top");

        $(document).ajaxStart(function() {
            RISSB.fn.block();
        });

        $(document).ajaxStop(function() {
            RISSB.fn.unblock();
        });

        $(window).on("scroll", function() {
            $backToTop.toggleClass("d-none", $(this).scrollTop() === 0);
        });

        $backToTop.on("click", function() {
            $("html, body").animate(
                {
                    scrollTop: 0
                },
                250
            );
        });

        $(".js-toggle-password").on("click", function() {
            var $this = $(this);
            var $input = $this.closest(".input-group").find(".form-control");

            if ($this.find('[data-prefix="fas"], i').hasClass("fa-eye-slash")) {
                $input.attr("type", "text");
                $this
                    .find('[data-prefix="fas"], i')
                    .removeClass("fa-eye-slash")
                    .addClass("fa-eye");
            } else {
                $input.attr("type", "password");
                $this
                    .find('[data-prefix="fas"], i')
                    .removeClass("fa-eye")
                    .addClass("fa-eye-slash");
            }
        });

        $(document).on("click", ".js-dropdown-filter .dropdown-menu", function(
            e
        ) {
            e.stopPropagation();
        });

        $(document).on(
            "change",
            '.js-dropdown-filter input[type="checkbox"]',
            function(e) {
                var $dropdown = $(this).closest(".dropdown");

                $dropdown.toggleClass(
                    "has-checkable-items",
                    $dropdown
                        .find('.dropdown-menu input[type="checkbox"]')
                        .filter(":checked").length > 0
                );
            }
        );

        $(".js-accordion-content").on("show.bs.collapse", function(e) {
            $(e.currentTarget)
                .closest("fieldset")
                .find(".js-toggle-accordion")
                .attr("data-icon", "chevron-down");
        });

        $(".js-accordion-content").on("hide.bs.collapse", function(e) {
            $(e.currentTarget)
                .closest("fieldset")
                .find(".js-toggle-accordion")
                .attr("data-icon", "chevron-right");
        });

        $(".bbp-breadcrumb-home").attr("href", "/grandcentral");

        $("#search-webinar").keydown(function(e) {
            if (e.keyCode == 13) {
                $(".search-container").show();
            }
        });

        $("#webinar-submit").click(function() {
            $(".search-container").show();
        });
    });

    $(".menu-item-31381 a").click(function() {
        window.location.href = "https://ariso.org.au/events/";
    });

    $(".menu-training-lms a").click(function() {
        window.location.href = "https://training.ariso.org.au/";
    });

    window.RISSB = RISSB;

    $(document).ready(function() {
        $(".btn-filter-product").click(function() {
            $(".btn-filter-product").toggleClass("active");
        });
        // $('.products-cart').click(function(event) {
        //     if ($(event.target).is('.products-cart, .products-cart > *')) {
        //         $(this).toggleClass('show');
        //     }
        // });
        // Ensure both elements can be focused
        $(".products-cart, .product-queue-modal").attr("tabindex", "0");

        $(".products-cart").click(function(event) {
            if ($(event.target).is(".products-cart, .products-cart > *")) {
                $(this).toggleClass("show");
                $(".product-queue-modal").toggleClass("d-none");
            }
        });

        $(".products-cart, .product-queue-modal").on("focusout", function(
            event
        ) {
            // Check if focus is moving to a descendant of either cart or modal
            if (
                !$(event.relatedTarget).closest(
                    ".products-cart, .product-queue-modal"
                ).length
            ) {
                $(".products-cart").removeClass("show");
                $(".product-queue-modal").toggleClass("d-none");
            }
        });

        $(".products-cart *").click(function(event) {
            if (!$(event.target).is(".products-cart > *")) {
                event.stopPropagation();
            }
        });

        $(".faq-accordion-wrapper").each(function() {
            var $faqSection = $(this);

            // Handle the FAQ question click event
            $faqSection.find(".faq-question").click(function() {
                $(this).toggleClass("active");
                $(this).children("i").toggleClass("rotate");
                $(this).next(".faq-answer").slideToggle();
            });

            // Distribute the FAQ items into two columns
            var faqItems = $faqSection.find(".faq-item");
            var col1 = $faqSection.find(".faq-column-1");
            var col2 = $faqSection.find(".faq-column-2");

            faqItems.each(function(index) {
                if (index % 2 === 0) {
                    col1.append($(this));
                } else {
                    col2.append($(this));
                }
            });
        });
    });

    $(document).ready(function() {
        function updateMediaCount() {
            var count = $(".js-list-products-queue .media").length / 3;

            if ($(".js-media-count").length === 0) {
                $('<span class="js-media-count ml-2">0</span>').insertAfter(
                    ".products-cart .fas.fa-shopping-cart"
                );
                $('<span class="js-media-count ml-2">0</span>').insertAfter(
                    ".nav-side-widget .fas.fa-shopping-cart"
                );
            }

            $(".js-media-count").text(count >= 1 ? count : 0);
        }

        // Initial count update
        updateMediaCount();

        // Update count on AJAX completion
        $(document).ajaxComplete(function() {
            updateMediaCount();
        });

        // Update count on item add/remove and clear actions
        $(document).on(
            "click",
            ".js-remove-product-from-queue, .js-add-product-to-queue, .js-clear-queue",
            function() {
                updateMediaCount();
            }
        );
    });

    //Table Navigation
    document.addEventListener('DOMContentLoaded', function () {
        const links = document.querySelectorAll('.table-nav .default');

        links.forEach(link => {
        link.addEventListener('click', function () {
            links.forEach(l => l.classList.remove('active'));
            this.classList.add('active');
        });
        });
    });

    document.addEventListener('DOMContentLoaded', function () {
        const links = document.querySelectorAll('.table-alcam-nav .default');

        links.forEach(link => {
        link.addEventListener('click', function () {
            links.forEach(l => l.classList.remove('active'));
            this.classList.add('active');
        });
        });
    });

})(jQuery);
